<template>
  <div class="app-screens" aria-hidden="true">
    <!-- Booking -->
    <div class="phone-mock phone-left">
      <div class="pm-screen">
        <p class="pm-title">Book a time</p>
        <div class="pm-days">
          <span v-for="d in days" :key="d.n" :class="{ on: d.on }"
            ><small>{{ d.d }}</small>{{ d.n }}</span
          >
        </div>
        <div class="pm-slots">
          <span v-for="t in slots" :key="t.t" :class="{ on: t.on }">{{ t.t }}</span>
        </div>
        <span class="pm-button">Confirm booking</span>
      </div>
    </div>
    <!-- Package tracking -->
    <div class="phone-mock phone-center">
      <div class="pm-screen">
        <p class="pm-title">Your packages</p>
        <div class="pm-card">
          <p class="pm-ref">Shipment #48213</p>
          <p class="pm-status"><i></i>In transit</p>
          <ol class="pm-steps">
            <li v-for="s in steps" :key="s.label" :class="s.state">{{ s.label }}</li>
          </ol>
        </div>
        <div class="pm-card pm-card-row">
          <span>Est. delivery</span><strong>Thu, 14 Nov</strong>
        </div>
        <span class="pm-button">Track package</span>
      </div>
    </div>
    <!-- Payment -->
    <div class="phone-mock phone-right">
      <div class="pm-screen pm-paid">
        <span class="pm-check">
          <svg viewBox="0 0 24 24"><path d="M5 12.5l4.2 4.2L19 7" /></svg>
        </span>
        <p class="pm-title">Invoice paid</p>
        <p class="pm-amount">J$12,500</p>
        <div class="pm-card pm-card-row"><span>Invoice</span><strong>#INV-1042</strong></div>
        <div class="pm-card pm-card-row"><span>Receipt</span><strong>Sent by WhatsApp</strong></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppScreens",
  data: () => ({
    days: [
      { d: "Mon", n: 11 },
      { d: "Tue", n: 12, on: true },
      { d: "Wed", n: 13 },
      { d: "Thu", n: 14 },
    ],
    slots: [{ t: "9:00" }, { t: "10:30", on: true }, { t: "1:00" }, { t: "3:30" }],
    steps: [
      { label: "Received in Florida", state: "done" },
      { label: "In transit", state: "now" },
      { label: "Customs", state: "" },
      { label: "Ready for delivery", state: "" },
    ],
  }),
};
</script>
